import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { getApi } from "../../../../ApiServices/api";
import { apiEndPoints } from "../../../../ApiServices/config";
import { useSelector } from "react-redux";
import { updateCart,removeFromCart } from "../../../../actions";
import toast from "react-hot-toast";

function useLoadMasterDataPuja() {
    const [makeDonationChecked, setMakeDonationChecked] = useState(false);
    const cartArr = useSelector((state) => state.cartArr);
    const isDevoteeLoggedIn = localStorage.getItem("token");
    const [totalAmount, setTotalAmount] = useState(0);
    const [expanded, setExpanded] = React.useState({});
    const [donationData, setDonationsData] = useState();
    const [donationItem, setDonationItem] = useState();
    const [donationAmount, setDonationAmount] = useState();
    const [error, setError] = useState("");
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const handleChange = (panel) => (event, newExpanded) => {
        setExpanded((prev) => ({
          ...prev,
          [panel]: newExpanded ? panel : false,
        }));
    };

    const handleEmptyPoojaBasket = () => {
        dispatch(updateCart());
    };

    const handleProceedToPay = () => {
        if (cartArr.length === 0) {
          toast.error(
            "Puja basket is empty, add services/donations before payment",
            {}
          );
        } else {
          if (isDevoteeLoggedIn) {
            navigate("/checkout");
          } else {
            navigate("/checkout-details");
          }
        }
    };

    const getAllDonations = async () => {
        const response = await getApi(apiEndPoints.getAllDonations);
        if (response && response.status === 200) {
          setDonationsData(response?.data?.data);
          setDonationItem(response?.data?.data[0]);
        }
    };

    const handleChildrenRemove = (item) => {
        dispatch(removeFromCart(item._id));
        toast.success("Item removed from the Basket");
    };

    const handleAddDonations = () => {
        if (Number(donationAmount) === 0) {
          toast.error("Donation amount must be greater than 0");
        } else if (Number(donationAmount) < donationItem?.amount) {
          toast.error(
            "Donation amount must be greater than or equal to donation minimum amount"
          );
        } else {
          const existingCartItem = cartArr.find(
            (cartItem) => cartItem._id === donationItem._id
          );
    
          if (existingCartItem) {
            const updatedItem = {
              ...existingCartItem,
              amount: donationAmount,
              type_id: 5,
              location: "",
              page: "services/donation",
            };
            dispatch(updateCart(updatedItem));
            toast.success("Your puja/donation is updated");
            setDonationAmount(0);
            setDonationItem(donationData[0]);
            setMakeDonationChecked(false);
          } else {
            const newItem = {
              ...donationItem,
              amount: donationAmount,
              type_id: 5,
              location: "",
              page: "services/donation",
            };
            dispatch(updateCart(newItem));
    
            setDonationAmount(0);
            setDonationItem(donationData[0]);
            setMakeDonationChecked(false);
          }
        }
    };

    const handleInputChange = (e) => {
        const input = e.target.value;
    
        const regex = /^[0-9]*\.?[0-9]*$/;
    
        if (regex.test(input)) {
          setDonationAmount(input);
          setError("");
        } else {
          setDonationAmount(input);
          setError("Only numeric values are allowed (no symbols or letters).");
        }
    };
    
    return {
        isDevoteeLoggedIn,
        dispatch,
        navigate,
        makeDonationChecked,
        setMakeDonationChecked,
        cartArr,
        totalAmount,
        setTotalAmount,
        expanded,
        setExpanded,
        donationData,
        setDonationsData,
        donationItem,
        setDonationItem,
        donationAmount,
        setDonationAmount,
        error,
        setError,
        handleChange,
        handleEmptyPoojaBasket,
        handleProceedToPay,
        getAllDonations,
        handleChildrenRemove,
        handleAddDonations,
        handleInputChange
    }

}
export default useLoadMasterDataPuja;